<template>
  <div class="first-section">
    <div class="heading">
      <div class="left">
        <h2>{{$ml.get(`Blend details`)}}</h2>
        <info-tip :title="$ml.get(`Insert name and the capacity of your spreader and click calculate blend`)"/>
      </div>
    </div>
    <div class="form">
      <!-- <app-text-input
        v-model="form.name"
        :label="$ml.get(`Blend name`)"
      /> -->
      <app-text-input
        v-model="form.capacity"
        :type="'number'"
        :max="15000"
        :label="$ml.get(`Container capacity`)"
        class="capacity"
        hint="kg"
        @input="validate()"
      />
      <div class="buttons">
        <app-btn @click="calc" :loading="loading.calc">
          {{ $ml.get(`CALCULATE BLEND`) }}
        </app-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      loading: {
        calc: false,
      }
    }
  },
  methods: {

    validate() {
      let val = this.form.capacity
      this.form.capacity = val > 0 ? val : -val
    },

    calc() {
      this.loading.calc = true;
      return this.$store.dispatch('program/blend/calc')
        .then(()=>{
          this.$store.dispatch('program/blend/save');
          this.$store.dispatch('program/canGoToNextStep', true);
        })
        .catch(this.handleErrorAsNotifications, this.store.dispatch('program/canGoToNextStep', false))
        .finally(() => {
          this.loading.calc = false;
        })
    },
  },
  computed: {
    ...mapGetters({
      form: 'program/blend/form',
      table: 'program/blend/table',
    }),
    buttonAvailable() {
      return !!this.table
    }
  }
}
</script>

<style lang="scss" scoped>

.first-section {
  // padding: 0 48px;
  // padding-top: 40px;
  .heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
    }
  }
  .title {
    font-size: 22px;
    font-weight: bold;

  }
  .form {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding-top: 50px;
    .text-input {
      margin-right: 30px;
      &.capacity {
        max-width: 200px;
      }
    }
    .buttons {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .report {
        margin-left: 20px;
      }
    }
  }
  @media (max-width: 1100px) {
    padding: 0;
  }
  @media (max-width:768px) {
    .form {
      flex-direction: column;
      align-items: flex-start;
      padding-top: 0;
      > div {
        margin-top: 32px;
        &.buttons {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          margin-top: 16px;
          button.report {
            margin-left: 0;
            margin-top: 16px;
          }
        }
      }
    }
  }
}

</style>
